import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { initialPath } from "~misc/paths";
import { getLocalStorage } from "~services/utils/SaveIndexBD";
const useHeader = () => {
  const [dateTimeLastFetch, setDateTimeLastFetch] = useState("");
  const location = useLocation();
  const path = location.pathname;
  const recebedorPath = path.startsWith(`${initialPath}/carteira/recebedor/novo`);
  const newEmissorPath = path.startsWith(`${initialPath}/carteira/emissor/novo`);
  const newProspectPath = path.startsWith(`${initialPath}/carteira/busca/online`);
  const [testId, setTesteid] = useState("");

  useEffect(() => {
    if (recebedorPath) {
      setTesteid("recebedor");
    } else if (newEmissorPath) {
      setTesteid("emissor");
    } else if (newProspectPath) {
      setTesteid("prospect");
    }
  }, [setTesteid, newEmissorPath, recebedorPath, newProspectPath]);

  const processLastFetchTime = async () => {
    const lastFetch = getLocalStorage("last-fetch-datetime-new");

    if(lastFetch)
      setDateTimeLastFetch(new Date(lastFetch));
  }

  useEffect(() => {
    processLastFetchTime();
  }, [])


  const carteiraPath = path.startsWith(`${initialPath}/carteira`);

  if (path)
    return {
      dateTimeLastFetch,
      processLastFetchTime,
      path,
      recebedorPath,
      newEmissorPath,
      testId,
      carteiraPath,
      newProspectPath,
      setDateTimeLastFetch
    };
};

export default useHeader;
